<template>
    <div>
        <!-- Export в ecxel -->
        <div class="flex justify-end mb-2">
            <vs-button
                color="success"
                id="button-load-more-posts"
                class="vs-con-loading__container ml-2"
                icon-pack="feather"
                icon="icon-download"
                @click="getExcelToken"
                >{{ $t("download_table") }}</vs-button
            >
        </div>
        <!-- Таблица с бесконечной прокруткой -->
        <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
        >
            <vs-table
                :noDataText="$t('no_data')"
                id="registration-results"
                :data="listResults"
            >
                <template slot="thead">
                    <vs-th>{{ $t("acad_periods") }}</vs-th>
                    <vs-th>{{ $t("faculty") }}</vs-th>
                    <vs-th>{{ $t("cathedra") }}</vs-th>
                    <vs-th>{{ $t("education_program_name") }}</vs-th>
                    <vs-th>{{ $t("groupp") }}</vs-th>
                    <vs-th>{{ $t("discipline-title") }}</vs-th>
                    <vs-th>{{ $t("students-fio-not-in-discipline") }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in listResults">
                        <vs-td :data="data[indextr].acad_period_repr_name">
                            {{ data[indextr].acad_period_repr_name }}
                        </vs-td>
                        <vs-td :data="data[indextr].faculty">
                            {{ data[indextr].faculty }}
                        </vs-td>

                        <vs-td :data="data[indextr].cathedra">
                            {{ data[indextr].cathedra }}
                        </vs-td>

                        <vs-td :data="data[indextr].education_program">
                            {{ data[indextr].education_program }}
                        </vs-td>

                        <vs-td :data="data[indextr].group">
                            {{ data[indextr].group }}
                        </vs-td>

                        <vs-td :data="data[indextr].discipline">
                            {{ data[indextr].discipline }}
                        </vs-td>
                        <vs-td :data="data[indextr].student">
                            {{ data[indextr].student.toString() }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: Boolean,
        filters: Boolean,
    },

    data() {
        return {
            listResults: [],
            page: 0,
            loading: false,
            infiniteStatus: true,
            status: true,
            interval: false,

            intervalParams: {
                token: null,
                uid: null,
            },
        };
    },
    watch: {
        active() {
            if (this.active) {
                this.loadMore();
            }
        },
        filters() {
            if (this.filters) {
                this.status = true;
                this.page = 0;
                this.listResults = [];
                this.loadMore();
            }
        },
    },
    created() {
        this.loadMore();
    },
    methods: {
        // Загрузка данных
        async loadMore() {
            if (this.active && this.status) {
                this.loading = true;

                this.$vs.loading();

                setTimeout(async () => {
                    this.page += 1;
                    let query = this.$route.query;
                    delete query["version-table"];
                    const res = (
                        await this.$http.get(
                            "advisors/not_registered/students/",
                            {
                                params: { page: this.page, ...query },
                            }
                        )
                    ).data;

                    res.results.forEach((el) => {
                        this.listResults.push(el);
                    });

                    if (res.next === null) {
                        this.status = false;
                    }

                    this.loading = false;
                    this.$vs.loading.close();
                }, 1000);
            }
        },
        async getExcelToken() {
            try {
                this.$vs.loading({
                    container: "#button-load-more-posts",
                    scale: 0.45,
                });
                let query = this.$route.query;
                delete query["version-table"];
                const res = await this.$http("reports/excel/not_registered/", {
                    params: query,
                });
                if (res.status === 200) {
                    this.intervalParams = res.data;
                    this.intervalParams.get = "status";

                    this.$vs.notify({
                        title: this.$t("file_process"),
                        time: 10000,
                        text: this.$t("some_time"),
                        color: "primary",
                        icon: "error",
                    });
                    this.interval = setInterval(async () => {
                        await this.getStatus();
                    }, 10000);
                }
            } catch (e) {}
        },
        async getStatus() {
            const res = await this.$http("/reports/get_file/", {
                params: this.intervalParams,
            });
            if (res.data.done) {
                clearInterval(this.interval);
                this.downloadFile();
            }
        },
        async downloadFile() {
            await this.$http
                .get("reports/get_file/", {
                    responseType: "blob",
                    params: { token: this.intervalParams.token, get: "file" },
                })
                .then((response) => {
                    // Создаю тег а виртуальный
                    const link = document.createElement("a");
                    // Добавляю к нему ссылку на закачку
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    // Устанавливаю к нему атрибуты названия файла и метод
                    link.setAttribute(
                        "download",
                        this.$t("unregister") + ".xls"
                    );
                    // Вставляю/заменяю тег а в конце body
                    document.body.appendChild(link);
                    // Произвожу клик
                    link.click();
                });

            this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>

<style>
#registration-results .vs-table--tbody-table {
    min-width: 0px !important;
}
</style>
